export default "__VITE_ASSET__jHcKm890__"